// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wf-logo[data-v-7aadc0fd]{margin-top:6px;margin-left:-6px;max-height:200px;max-width:400px}", ""]);
// Exports
module.exports = exports;
